<template>
  <h1 class="system_content_title">环保信用评价审核</h1>
  <div class="system_content_panels">
    <div class="systemPanel" style="position: relative; padding-bottom: 40px">
      <div class="selectors-box">
        <!-- 用户地区列表 -->
        <el-select v-model="userRegionSelect" placeholder="请选择地区" @change="resetPageinfo" filterable>
          <el-option v-if="userRegionList.length" v-for="item in userRegionList" :key="item.value" :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <!-- 用户指标列表 -->
        <el-select v-model="userIndexSelect" @change="indexSelectTrigger" placeholder="请选择评价工作">
          <el-option v-if="userIndexList.length" v-for="item in userIndexList" :key="item.value" :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <!-- 根据选择指标获取评价流程列表 -->
        <el-select v-model="userStepSelect" @change="resetPageinfo" placeholder="请选择评价流程">
          <el-option v-for="(item, index) in userStepList" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <!-- 选择是否已审核指标 -->
        <el-select v-model="selectedIsChecked" placeholder="请选择是否审核">
          <el-option v-for="item in selectedIsCheckedList" :key="item.value" :label="item.lable" :value="item.value">
          </el-option>
        </el-select>
        <el-input clearable v-model="userSearchInput" placeholder="输入公司名搜索" style="width: 180px"></el-input>
        <el-button type="primary" @click="getTableData">搜索</el-button>
        <!-- <el-button type="primary" style="background-color: #0086b3" @click="exportExcel">导出</el-button> -->
        <el-button v-if="StepIdFlag" type="danger" @click="backVerifys()" :loading="loading">批量退回</el-button>
        <el-button @click="putToVerify()" :loading="loading">未填报企业批量提交</el-button>
        <el-button @click="putToVerified()" :loading="loading">批量提交到已审核</el-button>
        <el-button @click="putNextVerify" :loading="loading" v-show="selectedIsChecked == 2">
          流程前进 / 批量
        </el-button>
      </div>
      <el-table :data="tableData" v-loading="tableLoading" stripe class="table_s" style="min-height: 70vh"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="65"> </el-table-column>
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="companyName" label="企业名称" sortable>
          <template #default="scope">
            <span v-html="scope.row.companyName"></span>
          </template>
        </el-table-column>
        <el-table-column prop="flowStepname" label="当前评审流程" sortable width="140">
        </el-table-column>
        <el-table-column prop="score1" label="自评分数" sortable>
        </el-table-column>
        <el-table-column prop="scorelevel1" label="自评结果">

          <template #default="scope">
            {{ scope.row.scorelevel1.slice(0, 4) }}
          </template>
        </el-table-column>
        <el-table-column prop="scorelevel1" label="自评等级">

          <template #default="scope">
            {{ replaceChinese(scope.row.scorelevel1) }}
          </template>
        </el-table-column>
        <el-table-column prop="score2" label="当前审核分数" sortable width="140">
        </el-table-column>
        <el-table-column prop="scorelevel2" label="当前审核结果">

          <template #default="scope">
            <!-- <p v-if="scope.row.scorelevel2 == '未填报' || scope.row.score2 == 0"></p> -->
            <p v-if="scope.row.score2 > 100">无效分数</p>
            <p v-else>{{ scope.row.scorelevel2.slice(0, 4) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="scorelevel2" label="当前审核等级">

          <template #default="scope">
            <!-- <p v-if="scope.row.scorelevel2 == '未填报' || scope.row.score2 == 0"></p> -->
            <p v-if="scope.row.score2 > 100">无效分数</p>
            <p v-else>{{ replaceChinese(scope.row.scorelevel2) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="regionFullName" label="行政区划" sortable width="160">
        </el-table-column>
        <el-table-column label="申诉资料" v-if="userStepSelect == '349'" :filters="[
          { text: '已申述', value: 1 },
          { text: '未申诉', value: 0 },
        ]" :filter-method="filterHandler" prop="IsAppealSubmit">

          <template #default="scope">
            <p v-if="scope.row.isAppealSubmit == 1" style="color: red">
              已申诉
            </p>
            <p v-else style="color: green">未申诉</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="auditable">

          <template #default="scope">


            <template v-if="scope.row.gblevel && scope.row.gblevel.includes('停产')">
              <el-tag class="ml-2" type="danger">停产</el-tag>
            </template>

            <template v-else>
              <el-button size="small" type="primary" @click="checkVerifyDetail(scope)">审核</el-button>
              <el-button v-if="scope.row.flowStepId>=StepIdNum" size="small" type="danger" @click="checkDeleteVerify(scope)">流程退回
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageInfo.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="10"
        layout="total, sizes, prev, pager, next, jumper" :total="pageInfo.totalRowCount" v-if="pageInfo.totalRowCount">
      </el-pagination>
      <el-dialog title="流程退回" v-model="dialogVisible2" width="40%" height="100%" @close="closeDialog">
        <h3>流程退回备注：</h3>
        <textarea autocomplete="off" style="min-height: 40px; height: 50px; width: 100%"
          v-model="backVerifyRemark"></textarea>
        <el-button type="primary" @click="deleteVerify">确定</el-button>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import api from "../../http/apis";
// import FileSaver from 'file-saver';
// import XLSX from 'xlsx';

export default {
  data() {
    return {
      userRegionList: [],
      userRegionSelect: "",
      // userRegionSelect:2472 ,
      // userRegionSelect:"",
      userIndexList: [],
      // userIndexSelect: 100,
      userIndexSelect: "",
      loading: false,
      tableLoading: false,
      auditable: false,
      userStepList: [
        // 	{
        // 	value: 32,
        // 	label: "县级"
        // },{
        // 	value: 33,
        // 	label: "市级"
        // },{
        // 	value: 346,
        // 	label: "省级"
        // },
      ],
      userStepSelect: "",
      tableData: [],
      selectedCompany: {},
      reviewDetailList: {},
      companyReviews: {
        companyName: "",
        reviewList: [],
      },
      pageInfo: {},
      userSearchInput: "",
      changeCompanyName: "",
      changeCompanyid: "",
      changeCompanyNameVisible: false,
      companyDetailVisible: false,
      reviewDetailVisible: false,
      selectedIsChecked: "",
      selectedIsCheckedList: {},
      dialogVisible: false,
      dialogVisible2: false,
      backVerifyRemark: "",
      DeleteVerifyShow: false,
      multipleSelection: [],
      json_fields: {
        评价指标: "ItemTitle",
        评价方法: "AuditsItemNames",
        分数: "Score",
        审核意见: "Remark",
        审核人: "CreatorName",
        审核时间: {
          field: "CreateTime",
          callback: (value) => {
            const date = value.split("T")[0];
            const time = value.split("T")[1];
            return `${date} ${time}`;
          },
        },
      },
      StepIdNum: 0,
      StepIdFlag: false
    };
  },
  created() {
    this.getListDatas();
    this.getStepId();
  },

  methods: {
    async getStepId() {
      const { data } = await api.auditionApi.getCanBackStepId();
      this.StepIdNum = Number(data.resultData);
    },
    async getListDatas() {
      this.selectedIsCheckedList = [];
      this.userRegionList = [];
      this.userIndexList = [];
      this.userStepList = [];

      this.selectedIsCheckedList.push({
        value: 1,
        lable: "未审核",
      });
      this.selectedIsCheckedList.push({
        value: 2,
        lable: "已审核",
      });
      // console.log(this.userStepList)
      const usrglist = await api.userApi.getUserRegionList();
      usrglist.data.resultObj.forEach((item) => {
        this.userRegionList.push({
          value: item.id,
          label: item.name,
        });
      });

      // console.log(this.userRegionList)
      const usidxlist = await api.reviewTaskApi.getTaskList({
        page: 1,
        rows: 99,
        order: "asc",
        sort: "id",
        value: "",
      });
      usidxlist.data.resultObj.data.forEach((item) => {
        this.userIndexList.push({
          value: item.id,
          label: item.title,
        });
      });
      this.indexSelectTrigger(this.userIndexList[0].value)
      this.userRegionSelect = this.userRegionList[0].value
    },
    async indexSelectTrigger(e) {
      this.userStepList = [];
      this.userIndexSelect = e;
      this.resetPageinfo();
      const usstlist = await api.reviewTaskApi.getUserStep();
      usstlist.data.resultObj.forEach((item) => {
        this.userStepList.push({
          value: item.id,
          label: item.name,
        });
      });
    },

    async checkVerifyDetail(scope) {
      // sessionStorage.setItem('AA', scope.row.id)
      // console.log('got company id  ' + scope.row.id)
      // this.$router.replace("#/system/reviewForm/verifyReview");

      const path = `/system/audition/auditionDetail?unitAID=${scope.row.id}`;
      let routeUrl = this.$router.resolve(path);
      window.open(routeUrl.href, "_blank");
    },
    async checkDeleteVerify(scope) {
      this.dialogVisible2 = true;
      this.tempItemId = scope.row.id;
      // console.log(scope.row.id)
    },
    async deleteVerify() {
      if (!this.backVerifyRemark) {
        ElMessage({
          message: "请填写备注！",
          type: "warning",
        });
        return;
      }
      const { data } = await api.auditionApi.backVerify(
        this.tempItemId,
        this.backVerifyRemark || ""
      );
      // console.log(data)
      if (data.isSuccessful) {
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
        this.getTableData();
      } else {
        this.$message({
          message: data.resultMsg || "[退回]未知错误，请联系管理员",
          type: "error",
        });
      }
      this.dialogVisible2 = false;
      this.tempItemId = null;
    },
    async putNextVerify() {
      this.loading = true;
      let idStr = ''
      this.multipleSelection.forEach(item => {
        idStr += item.id + ","
      })
      // console.log(this.multipleSelection[i])
      const { data } = await api.auditionApi.batchNextAuditionStep(idStr);
      if (data.isSuccessful) {
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
        this.loading = false;
      } else {
        this.loading = false;
        this.$message.error(data.resultMsg || "[批量前进]未知错误，请联系管理员");
      }
      this.getTableData();
      // console.log("1231312")
    },
    handleSelectionChange(data) {
      this.multipleSelection = [];
      // console.log(data)
      // this.multipleSelection.push(data.resultObj)
      // console.log(this.multipleSelection)
      data.forEach((item) => {
        this.multipleSelection.push({
          id: item.id,
          flowStepId: item.flowStepId
        });
      });
      this.multipleSelection.forEach(item => {
        console.log(item.flowStepId)
        console.log(this.StepIdNum)
        if (item.flowStepId < this.StepIdNum) {
          this.StepIdFlag = false
        } else {
          this.StepIdFlag = true
        }
      })
      console.log(this.multipleSelection)
    },
    async backVerifys() {
      this.loading = true;
      let ids = [];

      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      console.info(ids.toString());

      const { data } = await api.auditionApi.backVerify(
        ids.toString(),
        "批量退回"
      );
      this.loading = false;
      if (data.isSuccessful) {
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
      } else {
        this.$message({
          message: data.resultMsg || "[批量退回]未知错误，请联系管理员",
          type: "error",
        });
      }
      this.getTableData();
    },
    async closeDialog() {
      this.backVerifyRemark = "";
    },

    async getTableData() {
      // this.userStepSelect = e;
      // console.log(this.userStepSelect)
      this.auditable = false
      this.tableLoading = true
      const { data } = await api.reviewTaskApi.getPersonAuditionList({
        flowStepId: this.userStepSelect || 0,
        isAudit: this.selectedIsChecked || 0,
        regionId: this.userRegionSelect,
        headId: this.userIndexSelect,
        startIndex: this.pageInfo.startIndex || 0,
        page: this.pageInfo.pageIndex || 1,
        rows: this.pageInfo.pageSize || 10,
        value: this.userSearchInput,
        sort: "id",
      });
      if (this.userStepSelect) {
        this.auditable = true
      }
      if (data.isSuccessful && data.resultObj) {
        // console.log(data.resultObj.PagerInfo)
        // console.log(this.pageInfo)
        this.pageInfo = data.resultObj.pagerInfo;
        this.pageInfo.pageIndex = data.resultObj.pagerInfo.pageIndex;
        this.pageInfo.pageSize = data.resultObj.pagerInfo.pageSize;
        this.tableData = data.resultObj.data;
      }
      this.tableLoading = false
      // console.info(this.tableData);
    },
    async putToVerify() {
      this.loading = true;
      let ids = [];

      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      console.info(ids.toString());

      const { data } = await api.auditionApi.batchAdvanceStep(ids.toString());
      this.loading = false;
      if (data.isSuccessful) {
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
      } else {
        this.$message({
          message:
            data.resultMsg || "[未填报企业批量提交]未知错误，请联系管理员",
          type: "error",
        });
      }
      this.getTableData();
    },
    async putToVerified() {
      this.loading = true;
      let ids = [];

      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      console.info(ids.toString());

      const { data } = await api.auditionApi.batchAuditionSubmit(
        ids.toString()
      );
      this.loading = false;
      if (data.isSuccessful) {
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
      } else {
        this.$message({
          message: data.resultMsg || "[批量提交到已审核]未知错误，请联系管理员",
          type: "error",
        });
      }
      this.getTableData();
    },
    async checkAppealDetail(value) {
      // console.log(value)
      const href =
        "/#/system/reviewForm/guiZhouReviewAppeal?unitAID=" + value + "&type=1";
      window.open(href, "_blank");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    resetPageinfo() {
      this.pageInfo = {};
      // this.getTableData()
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    dateTrimmer(str) {
      if (str) {
        return str.split("T")[0];
      } else {
        return "无";
      }
    },
    timeTrimmer(str) {
      if (str) {
        return str.split("T")[1];
      } else {
        return "无";
      }
    },
    getFileName(val) {
      if (val != null) {
        if (val || val != "") {
          const fileUrl = val.split("/");
          const fileName = fileUrl.pop();
          return fileName;
        } else {
          const str = "无";
          return str;
        }
      }
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      // console.log(val)
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pageInfo.pageIndex = val;
      this.getTableData();
    },
    exportExcel() {
      /* generate workbook object from table */
      //表名
      var wb = XLSX.utils.table_to_book(document.querySelector(".table_s"));
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream",
          }),
          "表格.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    replaceChinese(str) {
      str = str.replace(/[\u4e00-\u9fa5]/g, "");
      return str;
    },
  },
};
</script>

<style></style>
